<h1 mat-dialog-title>
  Edit Object</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required/>
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required.</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>OID</mat-label>
      <input matInput formControlName="oid" required/>
      <mat-error *ngIf="form.get('oid')?.hasError('required')">OID is required.</mat-error>
      <mat-error *ngIf="form.get('oid')?.hasError('pattern')">The OID must follow the format "xx.xx.xx.xx" </mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</div>